/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.191.0-v202609092247-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqTreesApiClass {
 
   constructor() {}

  /**
   * @summary Add the specified items as child nodes of the specified parents within the specified tree. If an item is already a member of this tree, it will move from its current parent to the specified parent. The children of the items being moved will move with each parent. When x-sq-async-job header is set to 'true' the operation runs as an async job that may be queried using the Jobs API.
  */
  public batchMoveNodesToParents(
    body?: models.AssetTreeBatchInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/batch`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.ItemBatchOutputV1>;
  }

  /**
   * @summary Create or update an asset tree
  */
  public createTree(
    body?: models.AssetGroupInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/createTree`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AssetGroupOutputV1>;
  }

  /**
   * @summary Get a collection of all available tree types
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getAllTreeTypes(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get the ancestors and children of the specified item within the context of this tree
   * @param {string} id - ID of the specified item
   * @param {Array<string>} [scope] - The IDs of the workbooks to which the items are scoped&lt;br&gt;If scope is set to the Empty GUID then the scoped items are excluded.
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [includeDescendants=false] - If the children of the children should be retrieved. Note that a 400 error will be returned if the total number of children and descendants exceeds the specified limit
   * @param {boolean} [excludeGloballyScoped=false] - Exclude globally scoped items.
  */
  public getTree(
    {
      id,
      scope,
      offset,
      limit,
      includeDescendants,
      excludeGloballyScoped
    } : {
      id: string,
      scope?: Array<string>,
      offset?: number,
      limit?: number,
      includeDescendants?: boolean,
      excludeGloballyScoped?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['scope']: scope,      ['offset']: offset,      ['limit']: limit,      ['includeDescendants']: includeDescendants,      ['excludeGloballyScoped']: excludeGloballyScoped
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AssetTreeOutputV1>;
  }

  /**
   * @summary Get a collection of root nodes for the asset tree
   * @param {Array<string>} [scope] - The IDs of the workbooks to which the items are scoped&lt;br&gt;If the scope is set to the Empty GUID, then the scoped items are excluded.
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {Array<string>} [properties] - A list of property names and values to filter on.  Arguments should be passed in in the following format Property&#x3D;Value, with each new property-value pair on a new line. The option to filter out a node by a property can be done by using !&#x3D;.
   * @param {boolean} [excludeGloballyScoped=false] - Exclude globally scoped items.
  */
  public getTreeRootNodes(
    {
      scope,
      offset,
      limit,
      properties,
      excludeGloballyScoped
    } : {
      scope?: Array<string>,
      offset?: number,
      limit?: number,
      properties?: Array<string>,
      excludeGloballyScoped?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets`;

    const queryParams = {
      ['scope']: scope,      ['offset']: offset,      ['limit']: limit,      ['properties']: properties,      ['excludeGloballyScoped']: excludeGloballyScoped
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AssetTreeOutputV1>;
  }

  /**
   * @summary Add the specified items as child nodes of the specified parent within the specified tree. If an item is already a member of this tree, it will move from its current parent to the specified parent. The children of the item being moved will move with it.
   * @param {string} parentId - ID of the parent node
  */
  public moveNodesToParent(
    body: models.ItemIdListInputV1,
    {
      parentId
    } : {
      parentId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (parentId === null || parentId === undefined) {
      throw new Error("'parentId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/${encodeURIComponent(String(parentId))}`
      .replace('{parentId}', encodeURIComponent(String(parentId)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Add the specified items as root nodes of the specified tree. If an item is already a member of this tree, it will move to the root and its children will move with it
  */
  public moveNodesToRootOfTree(
    body: models.ItemIdListInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Trigger a rebuild of an asset tree search index in the background, starting at the specified root asset. This can be a time consuming and resource intensive operation, especially on large trees. The reindexing is performed in the background, and the API call will return as soon as the rebuild has been triggered.
   * @param {string} rootAssetId - ID the root asset of the tree to rebuild
   * @deprecated Instead of using this endpoint, please run an index for the root asset&#x27;s associated connector.
  */
  public rebuildSearchIndex(
    {
      rootAssetId
    } : {
      rootAssetId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (rootAssetId === null || rootAssetId === undefined) {
      throw new Error("'rootAssetId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/${encodeURIComponent(String(rootAssetId))}/rebuildSearchIndex`
      .replace('{rootAssetId}', encodeURIComponent(String(rootAssetId)));



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<{}>;
  }

  /**
   * @summary Remove an item and its children from the tree. (These items will still exist but not as part of this tree.)
   * @param {string} id - ID of the node to remove
  */
  public removeNodeFromTree(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'delete',
      url,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Scale a tree item across its asset tree. Asset-swapped copies of the item will be inserted under all assets at the same tree level as its current parent.
   * @param {string} id - ID of the item to be scaled
  */
  public scaleAcrossTree(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/${encodeURIComponent(String(id))}/scale`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      ...restOverrides
    }) as AxiosPromise<models.ScaleAcrossTreeOutputV1>;
  }

  /**
   * @summary Build a treemap
   * @param {string} start - The start time under which to compute conditions for the treemap.
   * @param {string} end - The end time under which to compute conditions for the treemap.
   * @param {Array<string>} conditionIds - The IDs of the conditions that will be used to create the treemap; must be in order of priority, where the first condition is the highest priority item.
   * @param {string} swapId - The ID of the asset to swap each treemap leaf node with.
   * @param {string} parentId - The ID of the parent asset to build the treemap from.
   * @param {Array<string>} [parameters] - Parameters for the display formulas. Each parameter should have a format of &#x27;name&#x3D;id&#x27; where &#x27;name&#x27; is the variable identifier, without the leading $ sign, and &#x27;id&#x27; is the ID of the item referenced by the variable
   * @param {Array<string>} [formulas] - A list of display scalar formulas
  */
  public treemap(
    {
      start,
      end,
      conditionIds,
      swapId,
      parentId,
      parameters,
      formulas
    } : {
      start: string,
      end: string,
      conditionIds: Array<string>,
      swapId: string,
      parentId: string,
      parameters?: Array<string>,
      formulas?: Array<string>
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (start === null || start === undefined) {
      throw new Error("'start' parameter required");
    }

    if (end === null || end === undefined) {
      throw new Error("'end' parameter required");
    }

    if (conditionIds === null || conditionIds === undefined) {
      throw new Error("'conditionIds' parameter required");
    }

    if (swapId === null || swapId === undefined) {
      throw new Error("'swapId' parameter required");
    }

    if (parentId === null || parentId === undefined) {
      throw new Error("'parentId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/treemap`;

    const queryParams = {
      ['start']: start,      ['end']: end,      ['conditionIds']: conditionIds,      ['swapId']: swapId,      ['parentId']: parentId,      ['parameters']: parameters,      ['formulas']: formulas
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.TreemapOutputV1>;
  }

  /**
   * @summary Update an asset tree
  */
  public updateTree(
    body?: models.AssetGroupInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/trees/assets/updateTree`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.AssetGroupOutputV1>;
  }

}


export const sqTreesApi = new sqTreesApiClass();

export type sqTreesApiEndpoints = {
  'batchMoveNodesToParents': {
    method: 'post';
    path: '/trees/assets/batch';
    response: models.ItemBatchOutputV1;
  };
  'createTree': {
    method: 'post';
    path: '/trees/assets/createTree';
    response: models.AssetGroupOutputV1;
  };
  'getAllTreeTypes': {
    method: 'get';
    path: '/trees';
    response: models.ItemPreviewListV1;
  };
  'getTree': {
    method: 'get';
    path: '/trees/assets/${encodeURIComponent(String(id))}';
    response: models.AssetTreeOutputV1;
  };
  'getTreeRootNodes': {
    method: 'get';
    path: '/trees/assets';
    response: models.AssetTreeOutputV1;
  };
  'moveNodesToParent': {
    method: 'post';
    path: '/trees/assets/${encodeURIComponent(String(parentId))}';
    response: models.StatusMessageBase;
  };
  'moveNodesToRootOfTree': {
    method: 'post';
    path: '/trees/assets';
    response: models.StatusMessageBase;
  };
  'rebuildSearchIndex': {
    method: 'post';
    path: '/trees/assets/${encodeURIComponent(String(rootAssetId))}/rebuildSearchIndex';
    response: {};
  };
  'removeNodeFromTree': {
    method: 'delete';
    path: '/trees/assets/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'scaleAcrossTree': {
    method: 'post';
    path: '/trees/assets/${encodeURIComponent(String(id))}/scale';
    response: models.ScaleAcrossTreeOutputV1;
  };
  'treemap': {
    method: 'get';
    path: '/trees/treemap';
    response: models.TreemapOutputV1;
  };
  'updateTree': {
    method: 'post';
    path: '/trees/assets/updateTree';
    response: models.AssetGroupOutputV1;
  };
};

type ApiBatchMoveNodesToParentsResponse = models.ItemBatchOutputV1;
type ApibatchMoveNodesToParentsMutationParams = Parameters<typeof sqTreesApi.batchMoveNodesToParents> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.batchMoveNodesToParents>;
type ApibatchMoveNodesToParentsMutationVariables = models.AssetTreeBatchInputV1 | undefined;

export function useApiBatchMoveNodesToParentsMutation(
  options?: Omit<UseMutationOptions<ApiBatchMoveNodesToParentsResponse, AxiosError<SeeqErrorData>,
    ApibatchMoveNodesToParentsMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiBatchMoveNodesToParentsResponse, AxiosError<SeeqErrorData>,
  ApibatchMoveNodesToParentsMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApibatchMoveNodesToParentsMutationVariables) =>
      sqTreesApi.batchMoveNodesToParents(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateTreeResponse = models.AssetGroupOutputV1;
type ApicreateTreeMutationParams = Parameters<typeof sqTreesApi.createTree> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.createTree>;
type ApicreateTreeMutationVariables = models.AssetGroupInputV1 | undefined;

export function useApiCreateTreeMutation(
  options?: Omit<UseMutationOptions<ApiCreateTreeResponse, AxiosError<SeeqErrorData>,
    ApicreateTreeMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateTreeResponse, AxiosError<SeeqErrorData>,
  ApicreateTreeMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateTreeMutationVariables) =>
      sqTreesApi.createTree(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiGetAllTreeTypesResponse = models.ItemPreviewListV1;
export function GetAllTreeTypesQueryKey(
  params: Parameters<typeof sqTreesApi.getAllTreeTypes>[0],
) {
  return ['sqTreesApi', 'getAllTreeTypes', params] as const;
}

export function useApiGetAllTreeTypesQuery(
  params: Parameters<typeof sqTreesApi.getAllTreeTypes>[0],
  options?: Omit<UseQueryOptions<ApiGetAllTreeTypesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAllTreeTypesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAllTreeTypesQueryKey(params),
    queryFn: () =>
      sqTreesApi.getAllTreeTypes(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTreeResponse = models.AssetTreeOutputV1;
export function GetTreeQueryKey(
  params: Parameters<typeof sqTreesApi.getTree>[0],
) {
  return ['sqTreesApi', 'getTree', params] as const;
}

export function useApiGetTreeQuery(
  params: Parameters<typeof sqTreesApi.getTree>[0],
  options?: Omit<UseQueryOptions<ApiGetTreeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTreeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTreeQueryKey(params),
    queryFn: () =>
      sqTreesApi.getTree(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetTreeRootNodesResponse = models.AssetTreeOutputV1;
export function GetTreeRootNodesQueryKey(
  params: Parameters<typeof sqTreesApi.getTreeRootNodes>[0],
) {
  return ['sqTreesApi', 'getTreeRootNodes', params] as const;
}

export function useApiGetTreeRootNodesQuery(
  params: Parameters<typeof sqTreesApi.getTreeRootNodes>[0],
  options?: Omit<UseQueryOptions<ApiGetTreeRootNodesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetTreeRootNodesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetTreeRootNodesQueryKey(params),
    queryFn: () =>
      sqTreesApi.getTreeRootNodes(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiMoveNodesToParentResponse = models.StatusMessageBase;
type ApimoveNodesToParentMutationParams = Parameters<typeof sqTreesApi.moveNodesToParent> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.moveNodesToParent>;

export function useApiMoveNodesToParentMutation(
  options?: Omit<UseMutationOptions<ApiMoveNodesToParentResponse, AxiosError<SeeqErrorData>,
    ApimoveNodesToParentMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiMoveNodesToParentResponse, AxiosError<SeeqErrorData>,
  ApimoveNodesToParentMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApimoveNodesToParentMutationParams) =>
      sqTreesApi.moveNodesToParent(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiMoveNodesToRootOfTreeResponse = models.StatusMessageBase;
type ApimoveNodesToRootOfTreeMutationParams = Parameters<typeof sqTreesApi.moveNodesToRootOfTree> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.moveNodesToRootOfTree>;
type ApimoveNodesToRootOfTreeMutationVariables = models.ItemIdListInputV1;

export function useApiMoveNodesToRootOfTreeMutation(
  options?: Omit<UseMutationOptions<ApiMoveNodesToRootOfTreeResponse, AxiosError<SeeqErrorData>,
    ApimoveNodesToRootOfTreeMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiMoveNodesToRootOfTreeResponse, AxiosError<SeeqErrorData>,
  ApimoveNodesToRootOfTreeMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApimoveNodesToRootOfTreeMutationVariables) =>
      sqTreesApi.moveNodesToRootOfTree(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiRebuildSearchIndexResponse = {};
type ApirebuildSearchIndexMutationParams = Parameters<typeof sqTreesApi.rebuildSearchIndex> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.rebuildSearchIndex>;

export function useApiRebuildSearchIndexMutation(
  options?: Omit<UseMutationOptions<ApiRebuildSearchIndexResponse, AxiosError<SeeqErrorData>,
    ApirebuildSearchIndexMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRebuildSearchIndexResponse, AxiosError<SeeqErrorData>,
  ApirebuildSearchIndexMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApirebuildSearchIndexMutationParams) =>
      sqTreesApi.rebuildSearchIndex(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiRemoveNodeFromTreeResponse = models.StatusMessageBase;
type ApiremoveNodeFromTreeMutationParams = Parameters<typeof sqTreesApi.removeNodeFromTree> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.removeNodeFromTree>;

export function useApiRemoveNodeFromTreeMutation(
  options?: Omit<UseMutationOptions<ApiRemoveNodeFromTreeResponse, AxiosError<SeeqErrorData>,
    ApiremoveNodeFromTreeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiRemoveNodeFromTreeResponse, AxiosError<SeeqErrorData>,
  ApiremoveNodeFromTreeMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiremoveNodeFromTreeMutationParams) =>
      sqTreesApi.removeNodeFromTree(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiScaleAcrossTreeResponse = models.ScaleAcrossTreeOutputV1;
type ApiscaleAcrossTreeMutationParams = Parameters<typeof sqTreesApi.scaleAcrossTree> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.scaleAcrossTree>;

export function useApiScaleAcrossTreeMutation(
  options?: Omit<UseMutationOptions<ApiScaleAcrossTreeResponse, AxiosError<SeeqErrorData>,
    ApiscaleAcrossTreeMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiScaleAcrossTreeResponse, AxiosError<SeeqErrorData>,
  ApiscaleAcrossTreeMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApiscaleAcrossTreeMutationParams) =>
      sqTreesApi.scaleAcrossTree(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiTreemapResponse = models.TreemapOutputV1;
export function TreemapQueryKey(
  params: Parameters<typeof sqTreesApi.treemap>[0],
) {
  return ['sqTreesApi', 'treemap', params] as const;
}

export function useApiTreemapQuery(
  params: Parameters<typeof sqTreesApi.treemap>[0],
  options?: Omit<UseQueryOptions<ApiTreemapResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiTreemapResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: TreemapQueryKey(params),
    queryFn: () =>
      sqTreesApi.treemap(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdateTreeResponse = models.AssetGroupOutputV1;
type ApiupdateTreeMutationParams = Parameters<typeof sqTreesApi.updateTree> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqTreesApi.updateTree>;
type ApiupdateTreeMutationVariables = models.AssetGroupInputV1 | undefined;

export function useApiUpdateTreeMutation(
  options?: Omit<UseMutationOptions<ApiUpdateTreeResponse, AxiosError<SeeqErrorData>,
    ApiupdateTreeMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateTreeResponse, AxiosError<SeeqErrorData>,
  ApiupdateTreeMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApiupdateTreeMutationVariables) =>
      sqTreesApi.updateTree(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
